import React from 'react';
import { IndexRoute, Route } from 'react-router';
import cookie from './helper/cookie';

import UserQueries from './queries/UserQueries';
import AgentQuery from './queries/AgentQuery';
import AgentIdQuery from './queries/AgentIdQuery';
import ConversationIdQuery from './queries/ConversationIdQuery';

import Loading from './components/Loading';
import TodoApp from './components/TodoApp';
import TodoList from './components/TodoList';
import TodoListNew from './components/TodoListNew';

import Navbar from './components/navbar'
import App from './views/App.js'
import Login from './views/Login'
import Register from './views/Register'
import Projects from './views/manageProjects'
import Admin from './views/Home'
import CreateProject from './views/createProject';
import AllProjects from './views/AllProjects';
import AllCustomers from './views/AllCustomer';
import AllAgents from './views/AllAgents';
import Agentsettingspage from './views/AgentSettings';
import clientDashboard from './views/clientDashboard';
import Profile from './views/Profile'
import Forgot from './views/forgot'
import Reset from './views/reset'
import CreateForm from './views/questions'
import Responses from './views/responses'

export default (
  <div>
  <Route path="/login" renderLoading={Loading} component={Login} />
  <Route path="/register" renderLoading={Loading} component={Register} />
  <Route path="/forgot" renderLoading={Loading} component={Forgot} />
  <Route path="/reset" renderLoading={Loading} component={Reset} />
  <Route 
      path="/form/:projectId" renderLoading={Loading} component={Responses} 
      queries={ConversationIdQuery}
  />
  <Route
    path="/" renderLoading={Loading} component={Navbar}
  >
    <IndexRoute
      renderLoading={Loading} component={App}
      prepareParams={() => ({ status: 'any' })}
    />
    <Route
      path="/projects/:userId" renderLoading={Loading} component={Projects}
      queries={UserQueries}
    />
    <Route 
      path="/admin/:userId" renderLoading={Loading} component={Admin} 
      queries={AgentIdQuery}
    />
    <Route path="/create" renderLoading={Loading} component={CreateProject} />
    <Route 
      path="/createForm/:projectId" renderLoading={Loading} component={CreateForm} 
      queries={ConversationIdQuery}
    />
    <Route 
      path="/profile/:userId" renderLoading={Loading} component={Profile} 
      queries={AgentIdQuery}
    />
    <Route 
      path="/allprojects/:userId" renderLoading={Loading} component ={AllProjects} 
      queries={AgentIdQuery}
    />
    <Route
     path="/allcustomers/:userId" renderLoading={Loading} component ={AllCustomers} 
     queries={AgentIdQuery}
    />
    <Route 
      path="/allagents/:userId" renderLoading={Loading} component ={AllAgents}
      queries={AgentIdQuery}
    />
    <Route
      path="/admin/agents/:userId" renderLoading={Loading} component={AllAgents}
      queries={AgentQuery}
    />
    <Route 
      path="/agentSettings/:userId" renderLoading={Loading} component={Agentsettingspage} 
      queries={AgentIdQuery}
    />
    <Route 
      path="/:userId/project/:projectId" renderLoading={Loading} component={clientDashboard} 
      queries={ConversationIdQuery}
    />
  </Route>
  </div>
);



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/